import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import TrackOrder from "@/pages/TrackOrder";
import Research from "@/pages/Research";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import BulkQuote from "@/pages/BulkQuote";
import FAQ from "@/pages/FAQ";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Terms from "@/pages/Terms";
import Complaints from "@/pages/Complaints";
import GDPRPolicy from "@/pages/GDPRPolicy";
import AgeGate from "@/components/AgeGate";
import ScrollToTop from "@/components/ScrollToTop";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminHandoffs from "@/pages/admin/AdminHandoffs";
import AdminInventory from "@/pages/admin/AdminInventory";
import AdminProductEditor from "@/pages/admin/AdminProductEditor";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <CartProvider>
                    <BrowserRouter>
                        <Toaster theme="dark" position="bottom-right" />
                        <ScrollToTop />
                        <AgeGate />
                        <Routes>
                            <Route element={<Layout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/shop" element={<Shop />} />
                                <Route path="/product/:slug" element={<ProductDetail />} />
                                <Route path="/checkout" element={<Checkout />} />
                                <Route path="/order/:orderId" element={<OrderSuccess />} />
                                <Route path="/track-order" element={<TrackOrder />} />
                                <Route path="/research" element={<Research />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/account" element={<Account />} />
                                <Route path="/bulk-quote" element={<BulkQuote />} />
                                <Route path="/faq" element={<FAQ />} />
                                <Route path="/privacy" element={<PrivacyPolicy />} />
                                <Route path="/cookies" element={<CookiePolicy />} />
                                <Route path="/terms" element={<Terms />} />
                                <Route path="/complaints" element={<Complaints />} />
                                <Route path="/gdpr" element={<GDPRPolicy />} />
                            </Route>

                            {/* Admin area — custom AdminLayout (no public chrome) */}
                            <Route path="/admin" element={<AdminLayout />}>
                                <Route index element={<AdminDashboard />} />
                                <Route path="orders" element={<AdminOrders />} />
                                <Route path="quotes" element={<AdminQuotes />} />
                                <Route path="handoffs" element={<AdminHandoffs />} />
                                <Route path="inventory" element={<AdminInventory />} />
                                <Route path="products" element={<AdminProductEditor />} />
                            </Route>
                        </Routes>
                    </BrowserRouter>
                </CartProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
